<div class="w-100 d-flex flex-wrap surface-back radius-medium p-minus">
  <div class="container">
    <div class="icon-container">
      <img
        src="./wealth-assets/svg/bnpl-icon.svg"
        alt="اعتبار اقساطی"
      />
    </div>
    <div class="w-100 d-flex flex-wrap description-container">
      @if (bnplTitle()) {
        <p class="w-100 title">
          {{ bnplTitle() }}
        </p>
      }
      @if (bnplDescription()) {
        <p class="w-100 description">
          {{ bnplDescription() }}
        </p>
      }
    </div>

    @if (bnplHasAction()) {
      <ngx-button
        [mode]="'icon-only'"
        [style]="'link'"
        [leftIcon]="{ name: 'arrow-left', type: 'linear' }"
        [size]="'small'"
      >
      </ngx-button>
    }
  </div>
  @if (bnplWallet()) {
    <div class="w-100 d-flex flex-wrap mt-plus">
      <ngx-divider
        class="w-100"
        [orientation]="'horizontal'"
        [color]="BorderColorsEnum.Light"
      />

      <div class="w-100 d-flex align-items-start gap-tiny mt-medium">
        <ngx-icon
          class="text-oninvert-warning"
          [name]="'info-circle'"
          [type]="'bold'"
        />

        <p class="b-3">اگر اعتبار فعال (غیر سازمانی) با مبلغ کمتر دارید، اعتبار جدید جایگزین اعتبار قبلی خواهد شد.</p>
      </div>
    </div>
  }
</div>
